<template>
  <div class="--ShippingAccountes-tab animated fadeIn">
    <b-row>
      <b-col>
        <div class="tools">
          <shipping-account-form
            :hideAddButton="false"
            :companyId="companyId"
            :shippingAccountObj="activeShippingObj"
            ref="editModal"
            @hideModal="hideShippingAccountModal"
            @saved="refreshShippingAccountList"
          ></shipping-account-form>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <grid-component
          isResizable
          isReorderable
          :gridId="gridId"
          :itemData="shippingAccountsList"
          :fields="fields"
          :handleRowClick="onEdit"
          :navigationField="'shippingProviderName'"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { GRID_ID } from '@/shared/constants';

import ShippingAccountFields from './fields';
import ShippingAccountForm from './components/ShippingAccountForm';
import GridComponent from '@/shared/components/GridComponent';

export default {
  name: 'ShippingAccountsTab',
  components: {
    ShippingAccountForm,
    GridComponent
  },
  data() {
    return {
      shippingAccount: {},
      fields: ShippingAccountFields,
      gridId: GRID_ID.SHIPPING_ACCOUNTS_GRID,
      activeShippingObj: {}
    };
  },
  computed: {
    ...mapGetters('companies', ['companyById']),
    ...mapGetters('shippingAccount', [ 'shippingAccountsList' ]),
    company() {
      return this.companyById(this.companyId);
    },
    companyId() {
      return this.$route.params.id;
    },
  },
  methods: {
    ...mapActions('shippingAccount', [
      'getShippingAccounts'
    ]),

    async refreshShippingAccountList() {
      await this.getShippingAccounts(this.company.id);
    },

    async onAddNewShippingAccount() {
      this.$v.shippingAccount.$touch();

      if (this.$v.shippingAccount.$invalid) {
        this.openAlertBox({message: 'The entered data is incorrect. Enter new correct data'});
        return;
      }

      this.shippingAccount.id = 0;
      this.shippingAccount.companyId = this.company.id;

      await this.addNewShippingAccount(this.shippingAccount);

      this.onClear();
      this.refreshShippingAccountList();
    },

    async onEditShippingAccount() {
      this.$v.shippingAccount.$touch();

      if (this.$v.shippingAccount.$invalid) {
        this.openAlertBox({message: 'The entered data is incorrect. Enter new correct data'});
        return;
      }

      this.shippingAccount.companyId = this.company.id;

      await this.editShippingAccount(this.shippingAccount);

      this.onClear();
      this.refreshShippingAccountList();
    },

    onClear() {},

    async onEdit({ dataItem }) {
      this.activeShippingObj = dataItem;
      this.$bvModal.show('edit-shippingAccount-modal');
    },

    async hideShippingAccountModal() {
      this.activeShippingObj = {};
    },
  },
  mounted() {
    this.refreshShippingAccountList();
  },
};
</script>

<style lang="scss">
.company--ShippingAccountes-tab {
  .form-actions {
    .btn {
      margin-left: 10px;
      margin-bottom: 10px;
    }
  }
  .buttonHeader {
    position: fixed;
    top: 15%;
    left: 80%;
    z-index: 7;
  }
  .cancelButton {
    margin-right: 10px;
  }
}
</style>
